import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styled from 'styled-components';
import Skills from './Skills';
import Publications from './Publications';
import Education from './Education';
import Experience from './Experience';
const SkillsExperienceSection = styled.section `
  display: flex;
  gap: 32px;
  margin-bottom: 32px;
  position: relative;

  @media (max-width: 900px) {
    flex-direction: column;
    gap: 2rem;
  }
`;
const SectionGraphics = styled.div `
  position: absolute;
  inset: 0;
  z-index: 0;
  pointer-events: none;
  overflow: visible;

  svg {
    position: absolute !important;
    z-index: 1 !important;
    opacity: 0.25 !important;
    pointer-events: none;
    display: block !important;

    &.section-bar-graph {
      left: 220px !important;
      top: 400px !important;
      width: 100px !important;
      height: 60px !important;
    }

    &.section-pie {
      bottom: 20px !important;
      top: auto !important;
      left: 30% !important;
      width: 80px !important;
      transform: translate(-50%, -50%) rotate(45deg) !important;
    }

    &.section-line-chart {
      left: 300px !important;
      top: 100px !important;
      width: 200px !important;
      height: 200px !important;
      transform: translate(-50%, -50%) rotate(-15deg) !important;
    }
  }

  @media (max-width: 900px) {
    svg {
      width: 60px !important;
      height: 30px !important;
    }
  }
`;
const SkillsPublicationsLeft = styled.div `
  flex: 1 1 0;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 2.5rem;
`;
const ExperienceRight = styled.div `
  flex: 1 1 0;
  min-width: 0;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
`;
const SkillsExperience = () => {
    return (_jsxs(SkillsExperienceSection, { children: [_jsxs(SectionGraphics, { children: [_jsx("svg", { className: "section-bar-graph", width: "100", height: "60", viewBox: "0 0 100 60", children: _jsxs("g", { opacity: "0.25", children: [_jsx("rect", { x: "10", y: "40", width: "10", height: "20", fill: "#ffce3c" }), _jsx("rect", { x: "25", y: "30", width: "10", height: "30", fill: "#ffce3c" }), _jsx("rect", { x: "40", y: "20", width: "10", height: "40", fill: "#ffce3c" }), _jsx("rect", { x: "55", y: "10", width: "10", height: "50", fill: "#ffce3c" }), _jsx("polyline", { points: "15,40 30,30 45,20 60,10", fill: "none", stroke: "#111", strokeWidth: "2" })] }) }), _jsx("svg", { className: "section-pie", width: "40", height: "40", viewBox: "0 0 32 32", children: _jsxs("g", { opacity: "0.25", children: [_jsx("circle", { r: "16", cx: "16", cy: "16", fill: "#ffce3c" }), _jsx("path", { d: "M16 16 L16 0 A16 16 0 0 1 32 16 Z", fill: "#111" })] }) }), _jsx("svg", { className: "section-line-chart", width: "120", height: "40", viewBox: "0 0 120 40", children: _jsx("g", { opacity: "0.25", children: _jsx("polyline", { points: "0,35 20,30 40,32 60,18 80,25 100,10 120,20", fill: "none", stroke: "#ffce3c", strokeWidth: "3" }) }) })] }), _jsxs(SkillsPublicationsLeft, { children: [_jsx(Skills, {}), _jsx(Publications, {}), _jsx(Education, {})] }), _jsx(ExperienceRight, { children: _jsx(Experience, {}) })] }));
};
export default SkillsExperience;
